/**
 * Pure rules of the Dropdown `float` menu (M27 T11 rework 3, prototype placeFloat / openDd / the .opt keys). No React, no DOM — tested in
 * __tests__/dropdownFloat.test.ts. The component measures the page and passes numbers in.
 */

const GAP = 6        // between the field and the menu below it
const EDGE = 8       // to the window edge
const OBEN_GAP = 8   // between the menu and the top of the field when it opens upward (the label stays visible)
const MIN_HOEHE = 96

export interface FloatEingabe {
  /** Trigger box (px, window coordinates). */
  trigger: { left: number; bottom: number; width: number }
  /** Top of the whole field (label + trigger). The menu opens above this line, so the label stays readable. */
  feldTop: number
  /** Lowest y the menu may reach: the window bottom, or the top of a bar that has to stay free (a phone's bottom bar). */
  grenzeUnten: number
  fensterBreite: number
  fensterHoehe: number
  /** Natural height of the menu (all rows, no limit). */
  hoehe: number
  /** Direction chosen when the menu opened; a later re-measure (scroll) keeps it instead of flipping. */
  nachObenFest?: boolean
}

export interface FloatPlatz {
  left: number
  width: number
  /** `top` XOR `bottom`: bottom means the menu opens upward. */
  top?: number
  bottom?: number
  maxHeight: number
  nachOben: boolean
}

/** As wide as the trigger; below it when the rows fit there; else upward when above has more room (then the menu scrolls inside its limit). */
export function floatPlatz(e: FloatEingabe): FloatPlatz {
  const width = Math.max(0, Math.min(e.trigger.width, e.fensterBreite - 2 * EDGE))
  const left = Math.max(EDGE, Math.min(e.trigger.left, e.fensterBreite - width - EDGE))
  const unten = e.grenzeUnten - e.trigger.bottom - GAP - EDGE
  const oben = e.feldTop - OBEN_GAP - EDGE
  const nachOben = e.nachObenFest ?? (e.hoehe > unten && oben > unten)
  return nachOben
    ? { left, width, bottom: e.fensterHoehe - e.feldTop + OBEN_GAP, maxHeight: Math.max(MIN_HOEHE, Math.floor(oben)), nachOben }
    : { left, width, top: e.trigger.bottom + GAP, maxHeight: Math.max(MIN_HOEHE, Math.floor(unten)), nachOben }
}

/** The row that gets the focus for an arrow key inside the open list (prototype: Down/Up stop at the ends, Home/End jump). -1 = not a list key. */
export function optionNach(taste: string, aktuell: number, anzahl: number): number {
  if (anzahl <= 0) return -1
  switch (taste) {
    case 'ArrowDown': return Math.min(anzahl - 1, aktuell + 1)
    case 'ArrowUp': return aktuell < 0 ? anzahl - 1 : Math.max(0, aktuell - 1)
    case 'Home': return 0
    case 'End': return anzahl - 1
    default: return -1
  }
}
